import type { AxiosResponse } from 'axios';

export function readBoolHeader(
  res: AxiosResponse,
  name: string,
): boolean | null {
  const headers = res.headers as unknown;

  if (typeof headers !== 'object' || headers === null) return null;

  const map = headers as Record<string, unknown>;
  const raw = map[name.toLowerCase()];

  if (typeof raw === 'string') return raw.toLowerCase() === 'true';
  if (Array.isArray(raw))
    return raw.some((v) => String(v).toLowerCase() === 'true');
  if (typeof raw === 'number') return raw === 1;
  return null;
}
